import { render, staticRenderFns } from "./BillWarrantyHistory.vue?vue&type=template&id=77c6740c&scoped=true"
import script from "./BillWarrantyHistory.vue?vue&type=script&lang=js"
export * from "./BillWarrantyHistory.vue?vue&type=script&lang=js"
import style0 from "./BillWarrantyHistory.vue?vue&type=style&index=0&id=77c6740c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6740c",
  null
  
)

export default component.exports